const TutoStep1 = () => (
  <div className="flex justify-center lg:h-[50vh] lg:w-[60vw]">
    <img src="/tuto/tuto-info.svg" className="w-full h-full" alt="tuto" />
  </div>
);

export default TutoStep1;
